import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { ChangeAnimation, NumberDisplay } from "@opensea/ui-kit";
export const CurrencyStatsTableRowFDVFragment = graphql(`
  fragment CurrencyStatsTableRowFDV on Currency {
    stats {
      marketCapUsd
    }
  }
`);
export function CurrencyStatsTableRowFDV(t0) {
  const $ = _c(7);
  const {
    currency: currencyKey
  } = t0;
  let t1;
  if ($[0] !== currencyKey) {
    t1 = readFragment(CurrencyStatsTableRowFDVFragment, currencyKey);
    $[0] = currencyKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currency = t1;
  const t2 = currency.stats?.marketCapUsd;
  const t3 = currency.stats?.marketCapUsd;
  let t4;
  if ($[2] !== t3) {
    t4 = <NumberDisplay bounded={false} display="usd" value={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <ChangeAnimation display="usd" value={t2}>{t4}</ChangeAnimation>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}